import { Component, OnInit, EventEmitter } from '@angular/core';
import { UserManagementService } from 'app/services/user-management.service';
import { Location } from '@angular/common';
import { Transition } from '@uirouter/angular';
import { FrontEndService } from "../../services/front-end.service";
import { LogService } from "app/services/log.service";

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss']
})

export class ResetPasswordComponent implements OnInit {
    errorMessage = "";
    password_error = false;
    password = "";
    confirm_password = "";
    IdOfUser: any;
    confirm_password_error = false;
    fullScreenLoader = false;

    // Focus variables
    public  password_focus =  new EventEmitter<boolean>();
    public  confirm_password_focus =  new EventEmitter<boolean>();

    constructor(
        private user_management_service: UserManagementService,
        private transition: Transition,
        public front_end_service: FrontEndService,
        private _location: Location,
        private logService: LogService
    ) {}

    ngOnInit() {
        this.IdOfUser = this.transition.params().user_id;
        if(!this.IdOfUser) {
            const current_user = JSON.parse(localStorage.getItem('currentUser'));
            this.IdOfUser = current_user.id;
            this.logService.printLog("this.IdOfUSer" + this.IdOfUser);
        }
    }

    onSubmit(pass) {
        const regPassword = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;

        if( pass["password"].trim() === "" || pass.password === undefined ) {
            this.password_error = true;
            this.password_focus.emit(true);
            this.password= "";
            this.errorMessage = 'enter_a_new_password';
        } else if(pass["password"].trim().length <=7) {
            this.password_error = true;
            this.password_focus.emit(true);
            this.password= "";
            this.errorMessage = 'enter_a_more_than_seven_digit_password';
        } else if( !regPassword.test(pass.password) ) {
            this.password_error = true;
            this.password_focus.emit(true);
            this.password= "";
            this.errorMessage = 'must_contain_capital_small_special_and_numeric_character';
        } else if( pass["confirm_password"].trim() === "" || pass.confirm_password === undefined) {
            this.confirm_password_error = true;
            this.password_error = false;
            this.confirm_password_focus.emit(true);
            this.confirm_password= "";
            this.errorMessage = 'confirm_your_new_password';
        } else if( pass.confirm_password !== pass.password ) {
            this.confirm_password_error = true;
            this.password_error = false;
            this.confirm_password_focus.emit(true);
            this.confirm_password= "";
            this.errorMessage = 'new_password_and_confirm_password_does_not_match';
        } else {
            this.confirm_password_error = false;
            this.password_error = false;
            this.fullScreenLoader = true;
            this.user_management_service.changePassword(pass, this.IdOfUser, (resp) => {
                this.fullScreenLoader = false;
                this.front_end_service.back();
            });
        }
    }

    cancel() {
        this.password= "";
        this.confirm_password= "";
    }
}
